import * as React from 'react';
import { Dialog } from '../Dialog/Dialog';
import { Icon } from '../Icon/icon';
import { dialogueErrorBody, dialogueErrorButton, TIMEOUT_TYPE } from '../../commonTypes/dialogueError.types';

export interface DialogueErrorProps {
  dialogueErrorBody: dialogueErrorBody;
  enableCloseIcon?: boolean;
  isModalOpen?: boolean;
  shouldCloseOnOverlayClick?: boolean;
  onModalClose?(): void;
}

export class DialogueError extends React.PureComponent<DialogueErrorProps> {
  static defaultProps = {
    isModalOpen: false,
    enableCloseIcon: true,
    shouldCloseOnOverlayClick: false,
    onModalClose: () => {},
  };

  closeConfirm = () => {
    const { dialogueErrorBody } = this.props;
    if (dialogueErrorBody.type === TIMEOUT_TYPE) {
      let redirectBtn = dialogueErrorBody.buttons.find((x) => x.redirectUrl != '');
      if (redirectBtn !== undefined) {
        window.location.href = redirectBtn.redirectUrl;
      } else {
        console.warn('No redirect link found. Closing modal with no further actions.');
      }
    }

    this.props.onModalClose();
  };

  mapButtons = (btn: dialogueErrorButton, i: number) => {
    return (
      <button key={i} onClick={(_) => this.doAction(btn.redirectUrl, btn.action)} className={btn.cssClassNames}>
        {btn.text}
      </button>
    );
  };

  doAction = (redirectUrl: string, action: string) => {
    this.closeConfirm();
    if (redirectUrl) {
      window.location.href = redirectUrl;
    }
  };

  public render() {
    const { dialogueErrorBody, isModalOpen, enableCloseIcon, shouldCloseOnOverlayClick } = this.props;

    return (
      <Dialog
        isOpen={isModalOpen}
        onRequestClose={this.closeConfirm}
        shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}>
        {enableCloseIcon && (
          <button onClick={this.closeConfirm} className="close">
            <Icon isAriaHidden={false} ariaLabel="Stäng" iconType="ic_close_white_24px" />
          </button>
        )}

        {dialogueErrorBody && (
          <React.Fragment>
            {dialogueErrorBody.body}
            <div className="footer">{dialogueErrorBody.buttons.map(this.mapButtons)}</div>
          </React.Fragment>
        )}
      </Dialog>
    );
  }
}
